module.exports = __webpack_public_path__ + "static/media/mentee_mentoring_about4.166b2038.webp";